const getDigits = (input) => (input ? input.replace(/[^0-9.]/g, '') : null);

export const parseDigits = (value) => {
  const parsed = String(value ?? '').trim();
  return parsed ? getDigits(parsed) : null;
};
